import { useMediaQuery } from "react-responsive";
import LoginPageDesktop from "./web/LoginPageDesktop";
import LoginPageMobile from "./mobile/LoginPageMobile";

const LoginPage = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });
  return <>{isMobile ? <LoginPageMobile /> : <LoginPageDesktop />}</>;
};

export default LoginPage;
